import Skeleton from '../../Skeleton';

import { Container } from './styles';

const LoadingUserBalance: React.FC<React.PropsWithChildren<unknown>> = () => {
  return (
    <Container>
      <div className="row">
        <Skeleton className="row-skeleton btc" />
      </div>
      <div className="row">
        <Skeleton className="row-skeleton currency" />
      </div>
    </Container>
  );
};

export default LoadingUserBalance;
